import { IManualSuscriptionAmountMinInversion } from '../../../../common/interfaces'

export const getAmountMinInversionForSelection = (
  records: IManualSuscriptionAmountMinInversion[],
  fundId: number | '',
  serieId: number | ''
): IManualSuscriptionAmountMinInversion | null => {
  if (fundId === '' || serieId === '') return null

  return records.find((record) => record.fund_id === fundId && record.serie_id === serieId) ?? null
}
